import React from 'react';

interface ComponentModule {
    default: React.ComponentType<any>;
}

type LazyImport<T = ComponentModule> = () => Promise<T>;

export function componentLoader<T>(lazyComponent: LazyImport<T>, attemptsLeft = 5) {
    return new Promise<T>((resolve, reject) => {
        lazyComponent()
            .then(resolve)
            .catch((error: unknown) => {
                // let us retry after 1500 ms
                setTimeout(() => {
                    if (attemptsLeft <= 0) {
                        reject(error);
                        return;
                    }
                    componentLoader(lazyComponent, attemptsLeft - 1).then(resolve, reject);
                }, 1500);
            });
    });
}

export function lazyComponentLoader(lazyComponent: LazyImport) {
    return React.lazy(() => componentLoader(lazyComponent));
}

export function lazyNamedComponentLoader<TModule extends Record<string, unknown>>(
    lazyComponent: LazyImport<TModule>,
    exportName: keyof TModule,
) {
    return React.lazy(() =>
        componentLoader(async () => ({
            default: (await lazyComponent())[exportName] as React.ComponentType<any>,
        })),
    );
}
